// Lightweight toast for field-app JS controllers that need to surface a
// transient message outside a request/response cycle -- e.g. compression
// exhaustion while queueing an offline photo, or a Raise a Ticket submission
// being sent or saved for later. Renders into the #flash-messages container
// that app/views/layouts/field.html.erb always provides, by cloning that
// layout's <template id="field-flash-template"> -- no markup built here.
//
// The message is always set as text, never HTML, so it's safe to include
// user-facing names (a Hub, a place) in it.
//
// Not for SurveyJS upload failures -- those already have a dedicated toast
// via ResultEditorController#showUploadError, fed through onUploadFiles'
// error callback. Use this for anything that happens outside that pipeline.
//
//   showFieldFlash("Couldn't prepare that photo")                  // warning
//   showFieldFlash("Sent – the General IT Hub has your ticket", { tone: "success" })
const TONES = {
  success: ["bg-emerald-50", "border-emerald-600", "text-emerald-800"],
  info: ["bg-sky-50", "border-sky-600", "text-sky-800"],
  warning: ["bg-yellow-400", "border-orange-700", "text-yellow-800"],
  error: ["bg-red-100", "border-red-700", "text-red-800"]
}

export function showFieldFlash(message, { tone = "warning", duration = 4000 } = {}) {
  const container = document.getElementById("flash-messages")
  const template = document.getElementById("field-flash-template")
  if (!container || !template) return

  const flash = template.content.firstElementChild.cloneNode(true)
  flash.dataset.tone = tone
  if (tone === "error") flash.setAttribute("role", "alert")
  flash.querySelector("[data-slot='box']").classList.add(...(TONES[tone] || TONES.warning))
  flash.querySelector("[data-slot='message']").textContent = message

  container.appendChild(flash)
  setTimeout(() => flash.remove(), duration)
}
